/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ENVIRONMENT } from '@gh/config';

@Injectable()
export class IntercomService {
  private window: Window;

  get isProd(): boolean {
    if (!['prod'].includes(ENVIRONMENT)) {
      console.warn("Intercom doesn't supported in dev mode!");
      return false;
    }
    return true;
  }

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.window = this.document.defaultView as Window;
 }

  showIntercom(): void {
    const intercom = this.window['Intercom'];
    if (this.isProd) {
      intercom('showSpace', 'home');
    }
  }

  trackIntercomEvent(event: string): void {
    const intercom = this.window['Intercom'];
    if (this.isProd) {
      intercom('trackEvent', event);
    }
  }
}
